<template>
  <breadCrumbs title="Sample Page" title1="Sample Page" />
  <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 text-start">
                <div class="card">
                    <div class="card-header pb-0">
                      <h3>Sample Card</h3><span>lorem ipsum dolor sit amet, consectetur adipisicing elit</span>
                    </div>
                    <div class="card-body">
                      <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</p>
                    </div>
                </div>
              </div>               
            </div>
        </div>
</template>
<script>
export default {
    
}
</script>